export const SUBDIVISIONS = [
  { id: 1, label: '1/4', symbol: '♩', desc: 'Quarti' },
  { id: 2, label: '1/8', symbol: '♫', desc: 'Ottavi' },
  { id: 3, label: 'Trip', symbol: '♪♪♪', desc: 'Terzine' },
  { id: 4, label: '1/16', symbol: '♬', desc: 'Sedicesimi' },
];

export const SOUND_TYPES = [
  { id: 'square', label: 'Electronic', desc: 'Click classico' },
  { id: 'sine', label: 'Smooth', desc: 'Onda sinusoidale' },
  { id: 'triangle', label: 'Mellow', desc: 'Più morbido' },
  { id: 'sawtooth', label: 'Buzz', desc: 'Sega aggressiva' },
  { id: 'noise', label: 'Woodblock', desc: 'Percussivo' },
  { id: 'cowbell', label: 'Cowbell', desc: 'Campanaccio' },
  { id: 'rimshot', label: 'Rim Shot', desc: 'Bordo del rullante' },
  { id: 'bell', label: 'Bell', desc: 'Campana cristallina' },
  { id: 'claves', label: 'Claves', desc: 'Bacchette in legno' },
  { id: 'snare', label: 'Snare', desc: 'Rullante' },
  { id: 'hihat', label: 'Hi-Hat', desc: 'Charleston chiuso' },
  { id: 'tom', label: 'Tom', desc: 'Tom basso' },
  { id: 'block', label: 'Block', desc: 'Block percussivo' },
  { id: 'ping', label: 'Ping', desc: 'Ping cristallino' },
  { id: 'kick', label: 'Kick', desc: 'Cassa profonda' },
];

// Quick kit presets — applied when user clicks a chip in Kit Drum mode.
// click→state=1 (pink), beat→state=2 (green), high→state=3 (sky)
export const KIT_PRESETS = [
  { id: 'rock',     label: 'Rock',     click: 'hihat',    beat: 'snare',   high: 'kick'    },
  { id: 'latin',    label: 'Latin',    click: 'claves',   beat: 'cowbell', high: 'tom'     },
  { id: 'click',    label: 'Click',    click: 'ping',     beat: 'noise',   high: 'bell'    },
  { id: 'vintage',  label: 'Vintage',  click: 'block',    beat: 'rimshot', high: 'cowbell' },
  { id: 'modern',   label: 'Modern',   click: 'hihat',    beat: 'block',   high: 'ping'    },
  { id: 'tribal',   label: 'Tribal',   click: 'tom',      beat: 'tom',     high: 'kick'    },
  { id: 'classic',  label: 'Classic',  click: 'square',   beat: 'square',  high: 'square'  },
  { id: 'sine',     label: 'Pure',     click: 'sine',     beat: 'triangle',high: 'bell'    },
];
